export const isFetchingFromAPI = (state) => !state.canInteract;
